import { desktopAuthorPostPageAdsBuilder } from "./desktopAuthorPostPageAdsBuilder";
import { mobileAuthorPostPageAdsBuilder } from "./mobileAuthorPostPageAdsBuilder";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { DomainPageClient } from "@repo/lib-domain-tag";
let isPageClientInitiated = false;
const PageTypeEnum = pageUtil.PageTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-var
declare var pbjs: any;
export const initPageClient_AuthorPostDetail = function () {
    if (isPageClientInitiated) return;
    isPageClientInitiated = true;
    const device = window.domainDevice || new deviceUtil.DeviceTypeInfo();
    const pageClient = new DomainPageClient();
    pageClient.device = device;
    pageClient.pageType = PageTypeEnum.authorPost;


    if (device.isMobile()) {
        pageClient.adsBuilder = mobileAuthorPostPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForMobile);
    } else {
        pageClient.adsBuilder = desktopAuthorPostPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForDesktop);
    }

    window.domainClient = pageClient;
    const isLoggedIn = pageClient.doesCookieExists('loggedIn') && pageClient.doesCookieExists('_sgf_facebook_name') && pageClient.doesCookieExists('_sgf_user_pids');
    pageClient.adsBuilder.setIsEnabled(!isLoggedIn);
    pageClient.adsBuilder.executeAsPbjsCommand(() => {
        pbjs.enableAnalytics({
            provider: 'yandex',
            options: {
                counters: [48985463],
            },
        });
    }
    );
    pageClient.adsBuilder.execute();
}
export const initPageClient_AuthorPostDetail_SpecialUseCaseAds = () => {
    let loadMoreIndex = 0;
    let intextIndex = 0;
    let nativoIndex = 0;

    document.addEventListener("loadmore", function () {
        loadMoreIndex++;
        console?.log("adsBuilder loadMoreIndex:", loadMoreIndex);
        //@ts-ignore
        window.domainTag.cmd.push(() => {
            //@ts-ignore
            window.domainClient.adsBuilder.executeLoadMoreAds(loadMoreIndex);
        });
    });

    document.addEventListener("ArticleIntext", function () {
        intextIndex++;
        console?.log("adsBuilder intextIndex:", intextIndex);
        //@ts-ignore
        window.domainTag.cmd.push(() => {
            //@ts-ignore
            window.domainClient.adsBuilder.executeIntextAds(intextIndex);
        });
    });
    document.addEventListener("NativoSlideChanged", function () {
        nativoIndex++;
        console?.log("adsBuilder nativoIndex:", nativoIndex);
        //@ts-ignore
        window.domainTag.cmd.push(() => {
            //@ts-ignore
            domainClient.adsBuilder.executeNativoAds(nativoIndex);
        });
    });
}
initPageClient_AuthorPostDetail();
initPageClient_AuthorPostDetail_SpecialUseCaseAds();
